<template>
  <div class="protocol login-protocol">
    <navigation>个人信息保护政策</navigation>
    <section class="content">
      <p class="text tab-2 tr"><strong>更新日期：2021年11月01日</strong></p>
      <p class="text tab-2 tr"><strong>生效日期：2021年11月01日</strong></p>
      <p class="text tab-2">
        欢迎您使用天美贷服务(<strong>以下简称"天美贷"或本"平台"</strong>)。作为天美贷的运营主体以及平台服务的提供方，我们(<strong>详见"附件：关键词定义"</strong>)深知个人信息对用户的重要性，并会尽全力保护用户的个人信息安全。我们尊重并保护用户隐私，在您使用平台服务时，我们恪守如下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们将按照本个人信息保护政策<strong>（以下简称“本政策”）</strong>以及业界成熟的安全标准收集、使用和共享您的个人信息。
      </p>
      <p class="text tab-2">
        <strong>本政策作为《天美贷平台用户注册协议》不可分割的组成部分，适用于平台本身向您提供的所有产品和／或服务(以下统称"平台服务")，在使用平台服务前，您知晓并确认您在注册时已经阅读本政策的所有内容，同意我们按照本政策来合法处理您的个人信息。为便于您阅读本政策，我们对所有可能与您的合法利益存在重大关系的条款以及涉及敏感信息内容都通过"加黑或下划线"的书写方式进行了特别提醒，并同时在"附件：关键词定义"中就敏感信息类别予以示例。在向我们提供任何个人敏感信息前，请您结合本政策相关条款清楚考虑该等提供是恰当的并确认是否同意我们可按本政策所述的目的和方式处理您的个人敏感信息。我们会在得到您的同意后收集和使用您的敏感信息，以实现与平台服务相关的功能。您可以拒绝向我们提供这些敏感信息，但是拒绝提供这些信息会影响您使用平台产品和/或服务项下的特定功能。</strong>
      </p>
      <p class="text tab-2"><strong>如果您不同意本政策的部分或全部内容，请您立即停止使用平台服务并通过平台客服或客服电话4000100008与我们联系。</strong></p>
      <p class="text tab-2">本政策将帮助您了解以下内容：</p>
      <p class="text tab-2">一、适用范围</p>
      <p class="text tab-2">二、我们如何收集您的个人信息</p>
      <p class="text tab-2">三、我们如何使用您的个人信息</p>
      <p class="text tab-2">四、我们如何共享、转让、公开披露您的个人信息</p>
      <p class="text tab-2">五、您如何管理自己的信息</p>
      <p class="text tab-2">六、Cookie和类似技术的使用</p>
      <p class="text tab-2">七、我们如何保存信息</p>
      <p class="text tab-2">八、您的个人信息保护</p>
      <p class="text tab-2">九、使用法律与争议解决</p>
      <p class="text tab-2">十、本政策的修订</p>
      <p class="text tab-2">十一、您如何联系我们</p>
      <p class="text tab-2">附件：关键词定义</p>
      <div>
        <p class="text tab-2"><strong>一、适用范围</strong></p>
      </div>
      <p class="text tab-2"><strong>本政策适用于平台提供的所有服务。</strong></p>
      <p class="text tab-2">
        <strong>但需要特别说明的是，如您在接受我们的关联公司或平台合作方提供的产品或服务时使用了本平台提供的全部或部分产品或服务（例如使用本平台账户登录）但未设独立法律声明及隐私权政策的，则本政策同样适用于本平台提供的该等全部或部分产品或服务。本政策不适用于由我们的关联公司、关联方或第三方合作机构直接向您提供的产品或服务。针对该等产品或服务，我们建议您在使用之前查看他们的隐私政策，了解他们如何处理您的信息，以便审慎决策。</strong>
      </p>
      <p class="text tab-2">
        <strong>本平台也可能含有到其他网站的链接，我们会依据法律法规的要求采取必要措施对相关网站进行审查（包括审查网站经营者的基本资质、通过技术手段对相关网站的安全情况进行合理且初步识别、督促该等网站经营者根据法律规定保护您的个人信息安全），但我们无法保证该等链接网站的运营方会按照我们的要求采取保护措施。我们建议您查看该等网站的隐私权政策或信息保护声明，了解他们如何处理您的信息，以便审慎决策。</strong>
      </p>
      <p class="text tab-2"><strong>本政策涉及的产品和／或服务仅供成年人使用，请您在使用相关产品和/或服务前确保您是18周岁(含)以上人士。如您未达到上述年龄的，请您立即终止使用本平台服务。</strong>
      </p>
      <div>
        <p class="text tab-2"><strong>二、我们如何收集您的个人信息</strong></p>
      </div>
      <p class="text tab-2">
        <strong>您同意并授权我们根据您使用的服务收集您如下与服务相关的必要信息。但是我们将不会向您收集法律法规禁止收集的个人信息。您可以选择不提供某一或某些信息，但是这样可能使您无法使用平台的部分服务</strong>，但这不会对您使用平台的其他服务产生影响<strong>。目前，本政策仅会出于以下目的收集您的个人信息，如确需改变信息收集的目的和类型时，我们将提前以合理的方式（如弹窗等）告知您并重新征得您的同意。</strong>
      </p>
      <p class="text tab-2"><strong>（一）会员账户的创建、关联或登录</strong></p>
      <p class="text tab-2"><strong>1.</strong>
        当您在平台创建账户时，我们将收集您的<strong class="underline">手机号码</strong>用以进行账户注册/登录。同时，平台合作方可能需要收集您的<strong class="underline">设备指纹信息</strong>，用于在借款申请时对用户身份进行验证，确保您的账户和资金的安全性。我们将用到合作的第三方服务机构（包括但不限于百融云创科技股份有限公司等）提供的设备指纹SDK产品对您的设备指纹相关信息进行验证；如您不同意我们收集、验证前述信息，您将无法完成会员账户的创建、关联、登录及借款申请。
      </p>
      <p class="text tab-2"><strong>2.</strong>
        您还可以使用“本机号码一键登录”的登录方式登录。<strong>您授权手机运营商根据网络认证当前本机SIM卡的手机号码，登录时免除输入手机号码、验证码操作，一键登录（一键登录时需通过您的SIM卡运营商网络进行）并注册。</strong>为了验证您的身份，极光一键登录SDK会采集您的<strong class="underline">个人常用设备信息（设备型号、系统时间、设备标示、CPU信息、屏幕尺寸、分辨率、系统语言、时区、版本号、系统类型、电池信息、WIFI信息、网络信息、经纬度信息、IP地址），</strong>平台合作方及运营商将收集您的<strong>SIM卡卡号。</strong>如果您不提供上述信息，则您无法使用一键登录功能，但不影响您对平台内容进行浏览。我们还将在本环节收集您的<strong class="underline">设备读写、存储权限信息（包括系统总容量、系统剩余储存空间、内存空间）</strong>，以便实现平台图片的缓存和取用，降低您的设备流量消耗。
      </p>
      <p class="text tab-2"><strong>3.</strong>
        为了防止欺诈风险，避免您的账号被非法盗用进而导致您账号中的信息泄露，同时保障您的账号财产安全，我们将在登录、借款申请、提现申请、还款及贷后管理等各个业务环节收集您的<strong class="underline">设备信息/电话权限（包括系统版本号、系统类型、设备平台、剩余电量、网络类型、wifi名称、wifi的bssid、设备dpi、蓝牙状态、设备品牌、设备型号、屏幕分辨率、屏幕亮度、是否为模拟器、是否root、MAC地址、IP地址）、唯一设备识别码（如Android
        ID、IMEI、IMSI、Unique ID、MAC地址、IDFA/IDFV）以及本机号码和设备指纹信息</strong>，每个环节仅单次获取。如果您未向我们提供上述一项或几项信息，不影响您使用天美贷各项功能。
      </p>
      <p class="text tab-2"><strong>4.</strong>
      <strong>您提供的上述信息，将在您使用本平台产品和服务期间持续授权我们使用。</strong>在您注销账号时，我们将停止使用并或对您的个人信息进行匿名化处理，法律法规另有规定的除外。</p>
      <p class="text tab-2"><strong>（二）提供借贷服务</strong></p>
      <p class="text tab-2"><strong>1. 授信环节</strong></p>
      <p class="text tab-2"><strong>为了协助金融机构风险审核和信用评估服务，满足反洗钱、反欺诈和对您的实名制验证管理要求，您需要向我们的合作金融机构或担保公司提供：</strong></p>
      <p class="text tab-2"><strong class="underline">（1）身份信息：包括您的姓名、证件类型、证件号码、证件有效期、证件影像；</strong></p>
      <p class="text tab-2"><strong class="underline">（2）用户基本信息：包括您的学历、婚姻状况、收入、居住地址、职业、单位名称及联系人信息。</strong></p>
      <p class="text tab-2">
        为方便您直接从通讯录选择联系人免于手动输入联系人手机号码的便利，您可选择允许获取<strong class="underline">通讯录读取权限</strong>，弹窗提示经您同意后自主开启权限，合作金融机构或担保公司会采集您的通讯录中联系人手机号码、姓名自动填充。
      </p>
      <p class="text tab-2"><strong>2.</strong> 提现环节</p>
      <p class="text tab-2">
        在您申请提现时，为了保障您的账号安全，我们合作金融机构或担保公司会与合法留存您身份信息的国家机关、金融机构、企事业单位进行多重交叉验证。您需要提供您的<strong class="underline">银行卡信息（包括银行卡类型、卡号、有效期、开户行名称、银行卡预留手机号）、活体人脸信息，并填写贷款用途。</strong>如您未提供上述个人信息以使我们的合作金融机构或担保公司完成交叉核验您的身份，根据国家相关法律法规实名制管理的要求，您将无法正常使用天美贷的提现服务功能，但不影响您使用我们提供的其他服务。
      </p>
      <p class="text tab-2">我们还将在本环节收集您的<strong class="underline">读写、存储权限（系统总容量、系统剩余储存空间、内存空间）</strong>，以保障您的账号财产安全。</p>
      <p class="text tab-2"><strong>3.</strong> 还款/贷后管理环节</p>
      <p class="text tab-2">
        当您使用还款/贷后管理服务时，如果您提现环节已提供的银行卡已失效或您主动选择使用其他银行卡还款，则为了对您的身份信息及银行账户信息进行验证便于您完成相应还款，您需要提供您用于还款的<strong class="underline">银行卡信息（包括银行卡类型、卡号、有效期、开户行名称、银行卡预留手机号）。</strong>
      </p>
      <p class="text tab-2">
        如您的贷款发生逾期或其他费用逾期未支付等情形，为维护我们及/或贷款人的合法权益，合作金融机构或担保公司有权委托我们向合作的律师事务所、催收机构或我们认为可向您传达信息的联系人披露您的<strong class="underline">违约信息（包含贷款逾期信息）</strong>。
      </p>
      <p class="text tab-2"><strong>（三）</strong><strong>我们从其他第三方获得您的个人信息的情形</strong></p>
      <p class="text tab-2">
        为更好地向您提供产品和服务，也为了平台自身的风险防控，以及保护各方的合法权益，除了您在平台上明示同意并授权平台可以收集和使用通过您自主填写和提供的个人信息和资料外，在经过您的授权下（含在线签署的电子文件），我们、平台合作金融机构或担保公司可能从合法持有您个人信息的第三方机构（例如百行征信有限公司、北京微聚智汇科技有限公司）收集、查询您的<strong class="underline">征信信息、借款信息、运营商信息、信用评分等其他与借款审批、管理相关的个人信息</strong>，用于对您的信贷资格、信用及偿付能力进行审核，并提供匹配的信贷服务以及在后期对您进行必要的催收通知服务。该等第三方基于向提供前述查询服务之目的，可能会对经您授权提供的个人信息进行合法、必要的处理。同时，合作金融机构或担保公司将通过第三方机构对您提交或平台收集的用户信息（包括您的<strong>个人身份信息</strong>）进行核实、验证，并对获得的核实、验证结果进行查看、收集、使用和留存操作。
      </p>
      <p class="text tab-2"><strong>（四）根据相关法律法规及国家标准，在以下情形中，我们可能会依法收集并使用您的个人信息无需征得您的同意：</strong></p>
      <div>
        <p class="text tab-2"><strong>1.</strong>与我们履行法律法规规定的义务相关的；</p>
        <p class="text tab-2"><strong>2.</strong>与国家安全、国防安全直接相关的；</p>
        <p class="text tab-2"><strong>3.</strong>与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p class="text tab-2"><strong>4.</strong>与刑事侦查、起诉、审判和判决执行等直接有关的；</p>
        <p class="text tab-2"><strong>5.</strong>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您授权同意的；</p>
        <p class="text tab-2"><strong>6.</strong>所涉及的个人信息是您自行向社会公众公开的；</p>
        <p class="text tab-2"><strong>7.</strong>根据您要求签订和履行合同所必需的；</p>
        <p class="text tab-2"><strong>8.</strong>从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
        <p class="text tab-2"><strong>9.</strong>维护所提供的产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障；</p>
        <p class="text tab-2"><strong>10.</strong>法律法规规定的其他情形。</p>
      </div>
      <div>
        <p class="text tab-2"><strong>三、我们如何使用您的个人信息</strong></p>
      </div>
      <p class="text tab-2"><strong>（一）为更好地向您提供本服务，也为了我们自身的风险防控，以及保护各方的合法权益，您同意并授权我们在必要时将您的信息用于如下用途：</strong></p>
      <div>
        <div class="text tab-2">
          <p class="text tab-2"><strong>1.</strong>实现本政策中“我们如何收集您的个人信息”所述目的；</p>
          <p class="text tab-2"><strong>2.</strong>实名制管理：为保护您的账户安全，对您进行实名制管理，为此需要您的<strong class="underline">身份信息、银行卡信息及手机号</strong>，我们会将上述信息提交给第三方身份验证机构，对您所提供的信息进行识别、验证等；</p>
          <p class="text tab-2"><strong>3.</strong>信用及偿付能力评估：我们会使用您的<strong class="underline">身份信息、个人财产信息</strong>在业务展开过程中基于您的同意对您的信用及偿付能力进行评估；</p>
          <p class="text tab-2"><strong>4.</strong>提供借贷服务：在您使用平台提供的借贷申请及提现服务时，我们会使用您的<strong class="underline">身份信息、个人财产信息及其他经过您同意采集的信息</strong>处理您的申请、完成交易指令；</p>
          <p class="text tab-2"><strong>5.</strong>保障交易安全：为了提高您使用平台的安全性，我们会通过收集您的<strong class="underline">设备识别码、本机号码、指纹信息</strong>等在内的信息来判断您的账号风险；</p>
          <p class="text tab-2"><strong>6.</strong>开展内部数据分析和研究：我们使用收集的信息对产品使用情况进行统计和分析。<strong>我们会将所收集到的信息用于数据分析。例如，我们将收集到的信息用于分析形成不包含任何个人信息的统计类产品。</strong></p>
          <p class="text tab-2"><strong>7.</strong>委托处理：第三方金融机构及担保公司为了对您作出更准确的信用评估，或提高本应用的服务质量、降低服务成本，合作金融机构或担保公司经您同意并授权后委托我们协助完成部分服务或职责,包括但不限于（1）委托我们按照本合同的约定将委托方已经采取了脱敏、去标识化等保护措施的您的信息进行分析、加工和处理；（2）当您发生违反您已签署的协议约定而产生债务时，委托我们对您进行债务到期提醒或追索。</p>
          <p class="text tab-2"><strong>8.</strong>提供附加服务：如您购买了平台上展示的小美会员礼包，我们可能经您同意后向平台合作方（重庆领易付科技有限公司）共享您的天美贷账号信息（姓名、手机号码及订单信息），使您可以便捷地实现第三方会员账号的开通激活。我们将根据与平台合作方的约定，在您授权同意范围内使用您的相关信息。</p>
          <p class="text tab-2"><strong>9.</strong>本协议或其他协议中经您授权许可的其他使用方式。</p>
        </div>
      </div>
      <p class="text tab-2">
        希望您能够理解，为了向您提供更为细致与贴心的服务，我们的服务存在一定的发展与更迭。<strong>如在您使用部分服务尚未被前述说明所涵盖时，我们在此明确，基于提供该等更新服务，若我们需要新增收集或使用您的信息，我们会通过页面提示或授权协议约定的方式另行向您说明信息收集的范围与目的，并征得您的同意。</strong>
      </p>
      <p class="text tab-2"><strong>（二）设备权限调用说明</strong></p>
      <p class="text tab-2">
        在提供服务过程中，为了保证您能正常使用产品功能，我们可能会向系统申请开启您的设备权限，申请前我们会告知设备权限开启的目的并征询您的同意，您可以选择“允许”或“禁止”权限申请；申请成功后，您可以随时进入手机“设置-权限管理”中关闭相应权限，权限关闭后相关产品功能可能无法正常使用，但不影响您使用我们的其他服务。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请您参考设备及系统开发方说明或指引。
      </p>
      <div>
        <p class="text tab-2"><strong>1.读取电话权限：</strong></p>
      </div>
      <p class="text tab-2">
        当您运行天美贷时，我们会向您申请获取此权限，目的是正常识别您的<strong class="underline">本机识别码</strong>，以便完成安全风控、进行统计和服务推送。若您不想接收相关推送信息，可以根据本政策指引进行关闭。</p>
      <div>
        <p class="text tab-2"><strong>2.读写外部存储权限：</strong></p>
      </div>
      <p class="text tab-2">
        当您使用天美贷时中的头像设置、客服、图像识别、将文件下载至本地或打开使用本地文件时，您可以在登录环节或提现环节通过开启<strong class="underline">存储权限</strong>使用或保存图片、视频或文件。若您不开启此权限，您将无法使用与存储卡读取或缓存相关的功能，但不影响您使用其他服务。
      </p>
      <div>
        <p class="text tab-2"><strong>3.读取通讯录信息：</strong></p>
      </div>
      <p class="text tab-2">
        当您使用天美贷时，我们会在授信环节向您申请获取此权限，同意此权限后您可以无需手动填写联系人信息。您可以在手机系统权限管理中，自主选择开启或关闭授权。若您不开启此权限，不会影响您使用其他服务。</p>
      <div>
        <p class="text tab-2"><strong>4.获取GPS定位信息：</strong></p>
      </div>
      <p class="text tab-2">
        依据《商业银行互联网贷款管理暂行办法》的规定，为了符合地方法人银行不得跨注册地辖区开展互联网贷款业务的监管要求，确认您是否在准入区域，同时为了有效识别短时异地登录等账户异常操作行为保护您的账户安全，便于为您提供区域性、个性化、优质合规的信贷服务，您同意我们在您进行授信申请时收集您的<strong class="underline">具体位置信息</strong>，您需要授权开启“<strong class="underline">访问位置信息权限</strong>”，此时我们将向您弹窗进行申请。<strong>如您同意该申请，我们将收集经度及纬度并通过解析前述经纬度后获取您的<span class="underline">详细位置信息</span>，但我们不会收集您的行踪轨迹。</strong>您可以在手机系统权限管理中，自主选择开启或关闭授权。若您不开启此权限，不会影响您使用其他服务。
      </p>
      <div>
        <p class="text tab-2"><strong>5.使用麦克风权限：</strong></p>
      </div>
      <p class="text tab-2">
        当您使用天美贷时，我们会向您申请获取此权限，目的是为了在您使用提现服务时的身份验证环节通过语音交流的方式对您进行活体核验。您可以在手机系统权限管理中，自主选择开启或关闭授权。若您不开启此权限，您将无法完成身份验证或使用平台提供的提现相关服务，但不会影响您使用其他服务。
      </p>
      <div>
        <p class="text tab-2"><strong>6.使用相机权限：</strong></p>
      </div>
      <p class="text tab-2">
        当您使用天美贷时，我们会向您申请获取此权限，目的是为了在您使用提现服务时的身份验证环节对您进行人脸识别及人脸证件比对。您可以在手机系统权限管理中，自主选择开启或关闭授权。若您不开启此权限，您将无法完成身份验证或使用平台提供的提现相关服务，但不会影响您使用其他服务。
      </p>
      <p class="text tab-2">
      <strong>（三）当我们要将信息用于本政策未载明的其他用途时或当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。在征求您的同意后，本政策的其他约定同样适用该等信息。</strong></p>
      <div>
        <p class="text tab-2"><strong>四、我们如何共享、转让、公开披露您的个人信息</strong></p>
      </div>
      <p class="text tab-2"><strong>（一）共享</strong></p>
      <p class="text tab-2"><strong>1.</strong>
      <strong>我们承诺会根据相关法律法规及监管规定对您的信息承担保密义务。我们不会将您的个人信息与其他第三方进行共享或者对外转让，除非获得您明确的同意或授权。</strong></p>
      <p class="text tab-2"><strong>2.</strong>
      <strong>在共享信息前，我们会对我们的关联公司或第三方合作伙伴进行数据安全能力审核，与其签署严格的数据安全和保密协定，要求他们按照我们的说明、本政策采取相关的保密和安全措施来处理您的信息。</strong></p>
      <p class="text tab-2"><strong>3.</strong>
        为实现本个人信息保护政策中声明的目的，我们可能会与我们的供应商、服务提供商、顾问或代理人共享您的个人信息，以提供更好的客户服务和用户体验。这些供应商、服务提供商、顾问、代理人可能为我们提供技术基础设施服务，分析我们服务的使用方式，衡量广告和服务的有效性，提供客户服务和支付服务，进行学术研究和调查，或提供法律、财务与技术顾问服务。<strong>我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于与产品或服务无关的其他用途。</strong>
      </p>
      <p class="text tab-2">目前，我们的授权合作伙伴包括以下类型：</p>
      <p class="text tab-2">
        <strong>（1）为了向您提供更优质的服务，在必要的时候（如平台升级维护、告知借款申请进程等）向您推送系统通知、发送短信通知，我们会向分析服务、验证服务、数据服务、营销推广类的授权合作伙伴（如百融云创科技股份有限公司）提供<span class="underline">姓名、身份证号、手机号码等。</span></strong>
      </p>
      <p class="text tab-2">
        <strong>（2）服务提供商（如易宝支付有限公司、宝付网络科技（上海）有限公司）。为向您提供借贷服务和还款服务，我们将提供您的<span class="underline">姓名、银行卡信息</span>等给服务提供商（如易宝支付有限公司、宝付网络科技（上海）有限公司）。</strong>
      </p>
      <p class="text tab-2">
        <strong>（3）贷款机构、增信机构（担保机构）、风控机构（如反欺诈机构）、贷后机构。为更好地为您提供信贷产品服务，我们会将您<span class="underline">个人信息（如本平台账号ID、身份证件信息（姓名、身份证件号码、身份证件有效期、身份证影像、签发机关）、银行卡信息（姓名、银行卡影像、银行卡卡号、银行卡有效期限、所属银行、信用（卡）额度、还款日）、手机号码、工作信息（公司名称、所在城市）、学历、婚姻、联系人、平均月收入、贷款用途等信息）</span>共享给为您提供资金的贷款机构（如四川锦程消费金融有限责任公司，具体以您签订的借款协议为准）；将您的<span class="underline">个人信息（如本平台账号ID、身份证件信息（姓名、身份证件号码、身份证件有效期、身份证影像、签发机关）、银行卡信息（姓名、银行卡影像、银行卡卡号、银行卡有效期限、所属银行、信用（卡）额度、还款日）、人脸信息、手机号码、工作信息（公司名称、所在城市）、学历、婚姻、联系人、平均月收入、贷款用途等信息）</span>提供给增信机构（如江西华章汉辰融资担保集团股份有限公司，具体以您签订的协议展示为准）。</strong>
      </p>
      <p class="text tab-2">
        <strong>（4）征信机构（百行征信有限公司）、行业协会（如中国互联网金融协会）。为更好地为您提供信贷产品服务及维护社会信用体系建设，依据相关规定，我们会将您的<span class="underline">个人信息：本平台账号ID、身份证件信息（包括姓名、身份证件号码）、手机号码、居住信息（家庭地址）、职业信息（包括工作单位、单位地址）、学历、婚姻、借款订单信息（包括借款信息、还款信息、逾期信息）</span>共享给中国人民银行征信中心；我们会将您的<span class="underline">个人信息：本平台账户ID、身份证件信息（包括姓名、身份证件号码）、手机号码、学历、婚姻、借款订单信息（包括借款信息、还款信息、逾期信息）</span>共享给百行征信有限公司及中国互联网金融协会。</strong>
      </p>
      <p class="text tab-2"><strong>4.</strong>
        根据法律规定及合理商业习惯，在平台计划与其他公司合并或被其收购或进行其他资本市场活动（包括但不限于IPO，债券发行）时，以及其他情形下平台需要接受来自其他主体的尽职调查时，则平台在对其用户的信息进行特别处理以使该等信息无法识别特定个人且不能复原后，会把该等信息提供给必要的主体，并且平台会通过和这些主体签署保密协议等方式要求其对该等信息采取合理的保密措施；
      </p>
      <p class="text tab-2"><strong>5.</strong>
        当您因使用平台服务发生争议时，为了保护您或可能涉及的第三方的合法权益，我们可能会将您的<strong class="underline">姓名</strong>及<strong class="underline">有效证件号码</strong>、<strong class="underline">联系方式</strong>和与争议相关的信息提供给监管机关或您与可能涉及的第三方协议（如有）约定的其他争议解决机构，以便及时解决纠纷，但法律法规明确禁止提供的除外；
      </p>
      <p class="text tab-2"><strong>6.</strong>
        为遵守适用的法律法规、诉讼目的或者行政机关、司法机构依法提出的要求而披露您的个人信息。如果我们确定您出现违反适用的法律法规或本协议的情况，或为保护我们及我们关联公司或其他用户或公众的权利、财产或安全免遭损害，我们也可能披露关于您的信息，包括相关违规行为以及我们已对您采取的措施；及
      </p>
      <p class="text tab-2"><strong>7.</strong> 其他经您事先授权同意的情形。</p>
      <p class="text tab-2">
        <strong>此外，为了向您更好地提供服务，我们在平台中嵌入了以下第三方软件开发工具包开发服务商的SDK，我们可能会将您的以下个人信息提供给这些SDK开发服务商，以便更好地实现平台各项产品或服务的功能：</strong>
      </p>
      <table class="table">
        <tr>
          <td>
            <p class="text tab-2"><strong>SDK名称</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong>用途</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong>可能收集/使用个人信息范围</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong>使用环节</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong>第三方机构名称</strong></p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2"><strong>百融Mobile SDK</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong>用户身份认证，获取唯一用户gid--反欺诈风险控制</strong></p>
          </td>
          <td>
            <p class="text tab-2">
              <strong>设备标识、Mac地址、应用列表（包名、应用名、版本）、IMSI、fingerpring（设备的唯一标识）、设备信息包括：品牌、所在应用名称、所在应用版本号、所在应用包名、电信运营商名称、设备型号、手机屏幕分辨率、获取连接的速度、网络信号、获取设备基板名称、获取设备引导程序版本号、获取设备指令集名称（CPU的类型）、获取设备驱动名称、设备版本号、设备主机地址、获取设备制造商、设备标签、设备版本类型、系统源代码控制值、CPU信息、是否越狱、是否模拟、是否代理、当前磁盘总量、当前可用磁盘总量、是否开启调试模式、是否开启模拟地理位置、是否改机工具、开机时间、开机时长、电池信息、设备音量信息、系统时区、内存总量、语言列表、网络类型、移动国家码（MCC）、移动网络码（MNC）、统计标识符应用卸载次数、无线局域网是否开启、是否使用多开工具启动、当前位置geohash值、位置信息</strong>
            </p>
          </td>
          <td>
            <p class="text tab-2"><strong>登录/授信/提现环节单节点</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong> 百融云创科技股份有限公司</strong></p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2"><strong>极光一键登录</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong>用户使用本机号码一键登录</strong></p>
          </td>
          <td>
            <p class="text tab-2">
            <strong>设备型号、系统时间、设备标示、CPU信息、屏幕尺寸、分辨率、系统语言、时区、版本号、系统类型、电池信息、WIFI信息、网络信息、经纬度信息、IP地址</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong>登录环节单节点</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong>深圳市和讯华谷信息技术有限公司</strong></p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2"><strong>腾讯云身份认证</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong>身份证识别 SDK</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong>摄像头权限、网络权限、手机状态、设备型号、设备品牌，设备制造商、设备名称、系统版本、系统类型</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong>授信环节单节点</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong>腾讯云计算（北京）有限责任公司</strong></p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2"><strong>腾讯云活体识别</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong>活体识别SDK</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong>摄像头权限、网络权限、设备型号、设备品牌、设备制造商、设备名称、系统版本、系统类型</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong>首次提现确认环节</strong></p>
          </td>
          <td>
            <p class="text tab-2"><strong>腾讯云计算（北京）有限责任公司</strong></p>
          </td>
        </tr>
      </table>
      <p class="text tab-2"><strong>（二）转让</strong></p>
      <p class="text tab-2"><strong>我们不会将您的个人信息转让给除平台运营者及其关联公司外的任何公司、组织和个人，但以下情况除外：</strong></p>
      <p class="text tab-2"><strong>1.</strong> 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
      <p class="text tab-2"><strong>2.</strong>
        如果我们或我们的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将确保该等信息在转移时的机密性，并尽最大可能确保新的持有您个人信息的公司、组织继续受此政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
      </p>
      <p class="text tab-2"><strong>（三）公开披露</strong></p>
      <p class="text tab-2">我们仅会在以下情况下，公开披露您的个人信息：</p>
      <p class="text tab-2"><strong>1.</strong> 获得您的明确同意；</p>
      <p class="text tab-2"><strong>2.</strong> 基于法律法规、法律程序、诉讼或政府主管部门强制性要求下。</p>
      <p class="text tab-2"><strong>（四）共享、转让、公开披露个人信息事先征得授权同意的例外</strong></p>
      <p class="text tab-2"><strong>在以下情形中，共享、转让、公开披露个人信息无需事先征得个人信息主体的授权同意：</strong></p>
      <p class="text tab-2"><strong>1.</strong> 与我们履行法律法规规定的义务相关的；</p>
      <p class="text tab-2"><strong>2.</strong> 与国家安全、国防安全直接相关的；</p>
      <p class="text tab-2"><strong>3.</strong> 与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p class="text tab-2"><strong>4.</strong> 与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
      <p class="text tab-2"><strong>5.</strong> 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
      <p class="text tab-2"><strong>6.</strong> 您自行向社会公众公开的个人信息；</p>
      <p class="text tab-2"><strong>7.</strong> 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
      <div>
        <p class="text tab-2"><strong>五、您如何管理自己的信息</strong></p>
      </div>
      <p class="text tab-2">我们非常尊重您对个人信息的关注，并为您提供了管理个人信息的方法。您有权利查询、更正、管理、删除自己的信息并保护自己的隐私和安全。</p>
      <p class="text tab-2"><strong>1.</strong> 访问权</p>
      <p class="text tab-2">
        除法律法规规定的<strong>例外</strong>情况，无论您何时使用我们的服务，我们都会力求让您顺利访问自己的个人信息。<strong>您可以通过如下方式行使您的访问权利：</strong></p>
      <p class="text tab-2">（1）帐户信息：如果您希望访问或编辑您的帐户中的个人资料信息、更改您的密码、添加安全信息等，您可以在平台中执行此类操作。</p>
      <p class="text tab-2">（2）使用信息：您可以在我们的平台中查阅您发布的信息、搜索关键词的记录等。</p>
      <p class="text tab-2"><strong>2.</strong> 更正权</p>
      <p class="text tab-2">
        当您需要更新您的个人信息时，或发现我们处理您的个人信息有错误时，您有权作出更正或更新。<strong>您可以自行在相关平台进行更正，或通过反馈与报错、客服等渠道将您的更正申请提交给我们。</strong>在您进行更新或更正前，我们可能会先要求您验证自己的身份，然后再处理您的请求。
      </p>
      <p class="text tab-2"><strong>3.</strong> 删除权</p>
      <p class="text tab-2">发生以下情形，您可以向我们提出删除个人信息的请求：</p>
      <p class="text tab-2">（1）如果我们处理个人信息的行为违反法律法规；</p>
      <p class="text tab-2">（2）如果收集、使用您的个人信息，却未征得您的同意（但本文件明确不需要征求您同意的除外）；</p>
      <p class="text tab-2">（3）如果我们处理个人信息的行为违反了与您的约定；</p>
      <p class="text tab-2">（4）如果您不再使用我们的产品或服务，或您注销了账号；</p>
      <p class="text tab-2">（5）如果我们终止运营及服务。</p>
      <p class="text tab-2">如果我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，<strong>除非法律法规另有规定，或这些实体获得您的独立授权</strong>。</p>
      <p class="text tab-2">当您从我们的服务中删除信息后，<strong>我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息</strong>。</p>
      <p class="text tab-2"><strong>4.</strong> 注销权</p>
      <p class="text tab-2">
        <strong>我们为您提供申请注销的功能，您可通过拨打客服电话申请注销。</strong>一旦您注销账号，将无法使用与账号相关联的服务，因此请您谨慎操作。为了保护您或他人的合法权益，我们需要在为您注销账号前验证您的身份。除法律法规另有规定外，注销账号之后我们将停止为您提供对应的服务，也不再收集您的个人信息。
      </p>
      <p class="text tab-2"><strong>5.</strong> 管理问题</p>
      <p class="text tab-2">
        （1）如果您无法通过上述方式访问、更正、删除、注销您的个人信息，或者您就我们收集、使用您信息有任何疑问或者问题，您都可以通过平台客服与我们联系。为保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份。我们将在收到您的反馈并验证您身份后15日内答复您的相关请求。
      </p>
      <p class="text tab-2">（2）我们将尽合理商业努力，满足您对于个人信息的查询、更正、管理的要求。但对于无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</p>
      <p class="text tab-2">（3）对于您合理的请求，我们原则上不收取费用，<strong>但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用</strong>。</p>
      <p class="text tab-2"><strong>6.</strong> 例外</p>
      <p class="text tab-2">按照法律法规要求，以下情况中，<strong>我们将无法响应您的请求：</strong></p>
      <div>
        <div class="text tab-2">
          <p class="text tab-2"><strong>（1）</strong>与我们履行法律法规规定的义务相关的；</p>
          <p class="text tab-2"><strong>（2）</strong>与国家安全、国防安全直接有关的；</p>
          <p class="text tab-2"><strong>（3）</strong>与公共安全、公共卫生、重大公共利益直接有关的；</p>
          <p class="text tab-2"><strong>（4）</strong>与刑事侦查、起诉、审判和执行判决等直接有关的；</p>
          <p class="text tab-2"><strong>（5）</strong>有充分证据表明您存在主观恶意或滥用权利的；</p>
          <p class="text tab-2"><strong>（6）</strong>响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
          <p class="text tab-2"><strong>（7）</strong>维护您或其他个人的生命、财产等重大合法权益但又很难得到您授权同意的；</p>
          <p class="text tab-2"><strong>（8）</strong>涉及商业秘密的。</p>
        </div>
      </div>
      <div>
        <p class="text tab-2"><strong>六、Cookie和类似技术的使用</strong></p>
      </div>
      <p class="text tab-2"><strong>1.</strong> 当您使用平台服务时，为使您获得更轻松的访问体验，我们可能会使用各种技术来收集和存储信息，在此过程中可能会向您的设备发送一个或多个 Cookie
      或匿名标识符。这么做是为了解您的使用习惯，使您省去重复输入注册信息等步骤，或帮助判断您的帐户安全。</p>
      <p class="text tab-2"><strong>2.</strong> 当您使用平台服务时，我们还可能会利用Cookie和类似技术收取您的信息用于了解您的偏好，进行咨询或数据分析，改善产品服务及用户体验。</p>
      <p class="text tab-2"><strong>3.</strong>
        <strong>我们不会将Cookie用于本政策所述目的之外的任何用途，请您理解，我们的某些服务只能通过使用Cookie才可得到实现。如您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝我们的Cookie。多数浏览器工具条中的“帮助”部分会告诉您怎样防止您的浏览器接受新的Cookie，怎样让您的浏览器在您收到一条新Cookie时通知您或者怎样彻底关闭Cookie。此外，您可以通过改变浏览器附加程序的设置，或通过访问提供商的网页，来关闭或删除浏览器附加程序使用的Flash
        Cookie及类似数据。但这一举动在某些情况下可能会影响您安全访问平台网站和使用平台提供的服务。</strong></p>
      <div>
        <p class="text tab-2"><strong>七、我们如何保存信息</strong></p>
      </div>
      <p class="text tab-2"><strong>1.</strong> 保存地域</p>
      <p class="text tab-2">
        您的个人信息将储存于中华人民共和国境内，除您在境外使用平台服务需要数据传输情形外，如需跨境传输，我们会在法律法规的允许范围内，按照法律、行政法规和相关监管部门的规定执行，向您告知出境的目的、涉及的个人信息类型、接收方身份、安全风险，且事先征得您的同意，并通过签订协议、安全评估、核查等有效措施，要求境外机构为所获得的个人信息保密并妥善处理，法律法规禁止跨境传输的个人信息除外。
      </p>
      <p class="text tab-2"><strong>2.</strong> 保存期限</p>
      <p class="text tab-2">除非法律法规另有规定，我们将按如下期间保存您的信息：</p>
      <p class="text tab-2">我们将在实现本政策中所述目的所必需的期间内保留你的个人信息，除非法律法规要求或允许在更长的期间内保留这些信息。</p>
      <p class="text tab-2">您的个人信息经匿名化处理后将形成可以使用及流通的数据，我们对此类数据的保存及处理无需另行通知并征得您的同意。</p>
      <p class="text tab-2"><strong>3. </strong>安全事件</p>
      <p class="text tab-2">
        如不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您的补救措施等。<strong>我们会及时将事件相关情况以站内通知、短信通知、电话、邮件等您预留的联系方式告知您，难以逐一告知时我们会采取合理、有效的方式发布公告。</strong>
      </p>
      <p class="text tab-2">
        我们会及时处置系统漏洞、网络攻击、病毒侵袭及网络侵入等安全风险。<strong>在发生危害网络安全的事件时，我们会按照网络安全事件应急预案，及时采取相应的补救措施，并按照规定向有关主管部门报告。</strong></p>
      <p class="text tab-2">如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或损毁，导致您的合法权益受损，我们将严格依照法律的规定承担相应的责任。</p>
      <div>
        <p class="text tab-2"><strong>八、您的个人信息保护</strong></p>
      </div>
      <p class="text tab-2">
        账户信息是非常重要的个人信息，您只能通过您的密码来使用您的账户。请使用复杂密码，协助我们保证您的账户安全。如果您泄漏了密码，您可能丢失了您的身份识别信息，并且可能出现对您不利的后果。因此，请您妥善设置、保管您在平台的账户信息。
      </p>
      <p class="text tab-2">
        我们有相应的安全措施来确保我们掌握的信息不丢失、不被滥用和变造，这些安全措施包括向其它服务器备份数据和对用户信息加密等。尽管我们有这些安全措施，但请注意在信息网络上不存在“完善的安全措施”。<strong>如您发现自己的个人信息泄密，尤其是您的账户或密码发生泄露，您应该立即通过平台客服与我们取得联系，以便我们采取相应措施。</strong>
      </p>
      <div>
        <p class="text tab-2"><strong>九、适用法律与争议解决</strong></p>
      </div>
      <p class="text tab-2"><strong>1.</strong> 适用法律</p>
      <p class="text tab-2">本政策的执行、解释及争议的解决均适用<strong>中华人民共和国法律。</strong></p>
      <p class="text tab-2"><strong>2.</strong> 争议解决</p>
      <p class="text tab-2">
        您和我们就本政策内容或其执行发生任何争议的，双方应友好协商解决；<strong>如双方无法协商解决争议时，双方同意应将争议提交至</strong>我公司主要办事机构<strong>所在地的人民法院诉讼解决。</strong>
      </p>
      <div>
        <p class="text tab-2"><strong>十、本政策的修订</strong></p>
      </div>
      <p class="text tab-2"><strong>我们可不定期修改本政策，变更后的政策将在平台公告或以其他适当方式进行公告。</strong></p>
      <p class="text tab-2">
        <strong>对于重大变更，我们会以特别的形式（包括但不限于弹窗）向您展示变更后的政策。请您注意，只有在您点击弹窗中的同意按钮后，我们才会按照变更后的隐私权政策收集、使用、共享、保存您的个人信息。本政策所指的重大变更主要有：</strong>
      </p>
      <div>
        <div class="text tab-2">
                    
          <p class="text tab-2"><strong>1.</strong>我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；</p>
          <p class="text tab-2"><strong>2.</strong>我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更；</p>
          <p class="text tab-2"><strong>3.</strong>您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
          <p class="text tab-2"><strong>4.</strong>我们负责处理个人信息安全等事项的联络方式及投诉渠道发生变化时；</p>
          <p class="text tab-2"><strong>5.</strong>个人信息安全影响评估报告表明存在高风险时。</p>
        </div>
      </div>
      <p class="text tab-2"><strong>我们还会将本政策的旧版本存档，您可以通过本政策约定的沟通渠道与我们联系并进行查阅。</strong></p>
      <div>
        <p class="text tab-2"><strong>十一、您如何联系我们</strong></p>
      </div>
      <p class="text tab-2"><strong>1.</strong> 客服渠道</p>
      <p class="text tab-2">
        如果您对本政策有任何疑问、意见或建议，或您在使用平台服务时，就您的个人信息的收集、使用、共享、访问、删除、更正等相关事宜有任何意见或建议，或您在使用平台服务时遇到任何问题，您都可以通过客服电话或平台上公布的电子邮箱与我们联系。
      </p>
      <p class="text tab-2">客服电话：4000100008</p>
      <p class="text tab-2"><strong>2.</strong> 特别提示</p>
      <p class="text tab-2"><strong>a.</strong> 我们提醒您，如您反馈的问题涉及您的个人信息，尤其是您的敏感信息，请您不要直接在电话或邮件中进行透露，我们将会在确保您个人信息安全的情况下与您进一步沟通。</p>
      <p class="text tab-2"><strong>b.</strong> 部分情况下，为保障您个人信息的安全，我们可能需要您提供书面请求，或以其他方式证明您的身份。我们将在收到您的反馈并验证您的身份后15日内答复您的相关请求。</p>
      <p class="text tab-2"><strong>附件：关键词定义</strong></p>
      <p class="text tab-2">为了帮助您更好的了解本政策，将前述条款中的部分名词进行解释如下：</p>
      <p class="text tab-2">•<strong>我们</strong>是指重庆市崇天小额贷款有限公司，注册地址：重庆市南岸区南滨路22号1栋长江国际大厦33层3319室；联系方式：4000100008。</p>
      <p class="text tab-2">•<strong>平台</strong>是指我们为用户提供服务的相应网站、移动客户端以及以其他形式提供的操作环境。</p>
      <p class="text tab-2">
        •<strong>Cookie</strong>是指支持服务器端（或者脚本）在客户端上存储和检索信息的一种机制，通过增加简单、持续的客户端状态来扩展基于Web的客户端/服务器应用。服务器在向客户端返回HTTP对象的同时发送一条状态信息，并由客户端保存。状态信息中说明了该状态下有效的URL范围。此后，客户端发起的该范围内的HTTP请求都将把该状态信息的当前值从客户端返回给服务器，这个状态信息被称为cookie。
      </p>
      <p class="text tab-2">•<strong>匿名化</strong>是指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。</p>
      <p class="text tab-2">
        •<strong>平台关联公司或关联公司</strong>是指与我们存在关联关系的公司的单称或合称。“关联关系”是指对于任何主体（包括个人、公司、合伙企业、组织或其他任何实体）而言，即其直接或间接控制的主体，或直接或间接控制其的主体，或直接或间接与其受同一主体控制的主体。前述“控制”指，通过持有表决权、合约或其他方式，直接或间接地拥有对相关主体的管理和决策作出指示或责成他人作出指示的权力或事实上构成实际控制的其他关系。
      </p>
      <p class="text tab-2">•<strong>平台合作机构或合作机构</strong>是指与我们签署相关合作或服务协议，同意根据协议约定并基于平台服务向用户提供记账提醒相关服务的机构。</p>
      <p class="text tab-2">•<strong>个人信息</strong>是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或反映特定自然人活动情况的各种信息。</p>
      <p class="text tab-2">
        •<strong>个人敏感信息</strong>是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。个人敏感信息包括个人财产信息、个人健康身理信息、人脸信息、个人身份信息、网络身份标识信息及其他信息。个人信息和个人敏感信息具有以《信息安全技术个人信息安全规范》GB/T35273-2020规定的为准。
      </p>
      <p class="text tab-2">个人信息举例（仅做展示，实际获取信息以个人信息保护政策条款为准）</p>
      <table>
        <tr>
          <td>
            <p class="text tab-2">个人基本信息</p>
          </td>
          <td>
            <p class="text tab-2">个人姓名、生日、性别、民族、家庭关系、住址、个人电话号码等</p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2">个人身份信息</p>
          </td>
          <td>
            <p class="text tab-2">可以识别您身份的信息，如姓名等（通过这些信息可以联系到您或识别您的身份）</p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2">人脸信息</p>
          </td>
          <td>
            <p class="text tab-2">面部特征</p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2">网络身份标识信息</p>
          </td>
          <td>
            <p class="text tab-2">系统账号及与前述有关的密码</p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2">个人教育工作信息</p>
          </td>
          <td>
            <p class="text tab-2">工作单位、学历</p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2">个人财产信息</p>
          </td>
          <td>
            <p class="text tab-2">银行账号、借贷记录、征信信息、交易和消费记录、流水记录等</p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2">个人通信信息</p>
          </td>
          <td>
            <p class="text tab-2">通信记录、短信、彩信、电子邮件，以及描述个人通信的数据（通常称为元数据）等</p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2">联系人信息</p>
          </td>
          <td>
            <p class="text tab-2">联系人名称、联系人的电话号码</p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2">个人上网记录</p>
          </td>
          <td>
            <p class="text tab-2">网站浏览记录、软件使用记录、点击记录</p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2">手机信息</p>
          </td>
          <td>
            <p class="text tab-2">手机号码、IMEI、IMSI</p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2">个人常用设备信息</p>
          </td>
          <td>
            <p class="text tab-2">指包括硬件序列号、设备MAC地址、手机机型、唯一设备识别码（如IMEI/android
            ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息、运营商名称、运营商编码等）等在内的描述个人常用设备基本情况的信息</p>
          </td>
        </tr>
      </table>
      <p class="text tab-2">个人敏感信息举例（仅做展示，实际获取信息以个人信息保护政策条款为准）</p>
      <table>
        <tr>
          <td>
            <p class="text tab-2">个人财产信息</p>
          </td>
          <td>
            <p class="text tab-2">银行账号、借贷记录、征信信息、交易和消费记录、流水记录等</p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2">个人生物识别信息</p>
          </td>
          <td>
            <p class="text tab-2">面部识别特征、指纹信息</p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2">网络身份标识信息</p>
          </td>
          <td>
            <p class="text tab-2">系统账号及与前述有关的密码用户个人数字证书等</p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2">其他信息</p>
          </td>
          <td>
            <p class="text tab-2">个人电话号码、通信记录和内容、行踪轨迹、网页浏览记录、精准定位信息</p>
          </td>
        </tr>
      </table>
    </section>
  </div>
</template>

<script>
export default {
  name: 'weibo-privacy',
  mounted () {
    this.$bus.$emit('ready')
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.login-protocol {
    background-color: white;
    .pr10{
        padding-right: 10px;
    }
    .tr{
        text-align: right;
    }
    table {
                border-spacing: 0;
                border-collapse: collapse;
                margin: unset;
                width:100%;
                td {
                    border-color: @fc3;
                    border-width: 1;
                    border-style: solid;
                    padding: 10px 0;
                    padding-left: 10px;
                    line-height: 1.4em;
                }
            }
    .content {
        padding: 0 48px;
        margin-top:0 !important;
        .title {
            font-weight: bolder;
            color: #333333;
            font-size: 28px;
            text-indent: 40px;
            line-height: 44px;
            margin-top: 10px;
        }
        .text {
            color: #333333;
            font-size: 28px;
            text-indent: 40px;
            line-height: 44px;
        }
        .text:last-child {
            margin-bottom: 10px;
        }
        .underline {
            text-indent: 40px;
            font-weight: bold;
            text-decoration: underline;
        }
        .underline:last-child {
            margin-bottom: 10px;
        }
    }
}
</style>
